import { render, staticRenderFns } from "./CreateNewTicket.vue?vue&type=template&id=1cbfb9be"
import script from "./CreateNewTicket.vue?vue&type=script&lang=js"
export * from "./CreateNewTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateNewTicket.vue?vue&type=style&index=0&id=1cbfb9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports